// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file tracker/v1/postback.proto (package tracker.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";
import { ConversionStatus } from "./conversion_pb.js";
import { DateRange, Money, Pagination, PaginationMeta } from "./common_pb.js";

/**
 * PostbackResult is what became of one postback.
 *
 * @generated from enum tracker.v1.PostbackResult
 */
export enum PostbackResult {
  /**
   * @generated from enum value: POSTBACK_RESULT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Accepted by the edge, not applied yet (or replay requested).
   *
   * @generated from enum value: POSTBACK_RESULT_PENDING = 1;
   */
  PENDING = 1,

  /**
   * Moved a conversion: a new one, or a new status/payout of an existing one.
   *
   * @generated from enum value: POSTBACK_RESULT_ACCEPTED = 2;
   */
  ACCEPTED = 2,

  /**
   * Changed nothing: the same state again, an older update, or a pending that
   * would have rolled a ruling back (detail says which).
   *
   * @generated from enum value: POSTBACK_RESULT_DUPLICATE = 3;
   */
  DUPLICATE = 3,

  /**
   * No such click yet (retrying), or the request carried no click id.
   *
   * @generated from enum value: POSTBACK_RESULT_NO_CLICK = 4;
   */
  NO_CLICK = 4,

  /**
   * The partner's status word is not mapped. NOT written as hold: map it
   * (MapPostbackStatus) and the postbacks are applied.
   *
   * @generated from enum value: POSTBACK_RESULT_UNKNOWN_STATUS = 5;
   */
  UNKNOWN_STATUS = 5,

  /**
   * Applied, but the currency has no rate: the payout is not in revenue until
   * fx_rates has its day (then it is backfilled automatically).
   *
   * @generated from enum value: POSTBACK_RESULT_NO_FX = 6;
   */
  NO_FX = 6,

  /**
   * Wrong token or a source IP outside the allowlist. Not applied.
   *
   * @generated from enum value: POSTBACK_RESULT_BAD_TOKEN = 7;
   */
  BAD_TOKEN = 7,

  /**
   * Unreadable: payout not a number, no currency, offer mismatch (detail).
   *
   * @generated from enum value: POSTBACK_RESULT_REJECTED = 8;
   */
  REJECTED = 8,
}
// Retrieve enum metadata with: proto3.getEnumType(PostbackResult)
proto3.util.setEnumType(PostbackResult, "tracker.v1.PostbackResult", [
  { no: 0, name: "POSTBACK_RESULT_UNSPECIFIED" },
  { no: 1, name: "POSTBACK_RESULT_PENDING" },
  { no: 2, name: "POSTBACK_RESULT_ACCEPTED" },
  { no: 3, name: "POSTBACK_RESULT_DUPLICATE" },
  { no: 4, name: "POSTBACK_RESULT_NO_CLICK" },
  { no: 5, name: "POSTBACK_RESULT_UNKNOWN_STATUS" },
  { no: 6, name: "POSTBACK_RESULT_NO_FX" },
  { no: 7, name: "POSTBACK_RESULT_BAD_TOKEN" },
  { no: 8, name: "POSTBACK_RESULT_REJECTED" },
]);

/**
 * @generated from message tracker.v1.PostbackRecord
 */
export class PostbackRecord extends Message<PostbackRecord> {
  /**
   * @generated from field: string event_id = 1;
   */
  eventId = "";

  /**
   * RFC3339
   *
   * @generated from field: string received_at = 2;
   */
  receivedAt = "";

  /**
   * @generated from field: string network_id = 3;
   */
  networkId = "";

  /**
   * @generated from field: string network_name = 4;
   */
  networkName = "";

  /**
   * @generated from field: string click_id = 5;
   */
  clickId = "";

  /**
   * @generated from field: string campaign_id = 6;
   */
  campaignId = "";

  /**
   * @generated from field: string campaign_name = 7;
   */
  campaignName = "";

  /**
   * @generated from field: string offer_id = 8;
   */
  offerId = "";

  /**
   * @generated from field: string goal_key = 9;
   */
  goalKey = "";

  /**
   * The partner's own status word, lower-cased.
   *
   * @generated from field: string raw_status = 10;
   */
  rawStatus = "";

  /**
   * @generated from field: tracker.v1.ConversionStatus status = 11;
   */
  status = ConversionStatus.UNSPECIFIED;

  /**
   * The conversion's status before this postback (UNSPECIFIED for a new one).
   *
   * @generated from field: tracker.v1.ConversionStatus previous_status = 12;
   */
  previousStatus = ConversionStatus.UNSPECIFIED;

  /**
   * @generated from field: tracker.v1.Money payout = 13;
   */
  payout?: Money;

  /**
   * payout in USD at write time; empty when there is no rate.
   *
   * @generated from field: string reporting_payout_usd = 14;
   */
  reportingPayoutUsd = "";

  /**
   * @generated from field: tracker.v1.PostbackResult result = 15;
   */
  result = PostbackResult.UNSPECIFIED;

  /**
   * Machine code explaining the result (status_rank_kept, click_not_seen_yet,
   * invalid_payout, no_rate_for_KZT, ...). The UI translates it.
   *
   * @generated from field: string detail = 16;
   */
  detail = "";

  /**
   * The partner's query string as received (credentials are in the path, never here).
   *
   * @generated from field: string raw_query = 17;
   */
  rawQuery = "";

  /**
   * edge:<key> for GetConversionTimeline; empty when no conversion moved.
   *
   * @generated from field: string conversion_key = 18;
   */
  conversionKey = "";

  /**
   * processed | waiting (will retry at next_attempt_at) | dead (gave up; a
   * late click or Replay revives it).
   *
   * @generated from field: string state = 19;
   */
  state = "";

  /**
   * @generated from field: string next_attempt_at = 20;
   */
  nextAttemptAt = "";

  constructor(data?: PartialMessage<PostbackRecord>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.PostbackRecord";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "received_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "network_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "network_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "click_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "campaign_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "campaign_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "offer_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "goal_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "raw_status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "status", kind: "enum", T: proto3.getEnumType(ConversionStatus) },
    { no: 12, name: "previous_status", kind: "enum", T: proto3.getEnumType(ConversionStatus) },
    { no: 13, name: "payout", kind: "message", T: Money },
    { no: 14, name: "reporting_payout_usd", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "result", kind: "enum", T: proto3.getEnumType(PostbackResult) },
    { no: 16, name: "detail", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 17, name: "raw_query", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 18, name: "conversion_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 19, name: "state", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 20, name: "next_attempt_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PostbackRecord {
    return new PostbackRecord().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PostbackRecord {
    return new PostbackRecord().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PostbackRecord {
    return new PostbackRecord().fromJsonString(jsonString, options);
  }

  static equals(a: PostbackRecord | PlainMessage<PostbackRecord> | undefined, b: PostbackRecord | PlainMessage<PostbackRecord> | undefined): boolean {
    return proto3.util.equals(PostbackRecord, a, b);
  }
}

/**
 * @generated from message tracker.v1.PostbackResultCount
 */
export class PostbackResultCount extends Message<PostbackResultCount> {
  /**
   * @generated from field: tracker.v1.PostbackResult result = 1;
   */
  result = PostbackResult.UNSPECIFIED;

  /**
   * @generated from field: int64 count = 2;
   */
  count = protoInt64.zero;

  constructor(data?: PartialMessage<PostbackResultCount>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.PostbackResultCount";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "result", kind: "enum", T: proto3.getEnumType(PostbackResult) },
    { no: 2, name: "count", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PostbackResultCount {
    return new PostbackResultCount().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PostbackResultCount {
    return new PostbackResultCount().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PostbackResultCount {
    return new PostbackResultCount().fromJsonString(jsonString, options);
  }

  static equals(a: PostbackResultCount | PlainMessage<PostbackResultCount> | undefined, b: PostbackResultCount | PlainMessage<PostbackResultCount> | undefined): boolean {
    return proto3.util.equals(PostbackResultCount, a, b);
  }
}

/**
 * @generated from message tracker.v1.ListPostbacksRequest
 */
export class ListPostbacksRequest extends Message<ListPostbacksRequest> {
  /**
   * @generated from field: tracker.v1.Pagination pagination = 1;
   */
  pagination?: Pagination;

  /**
   * Inclusive days; default the last 24 hours, at most 90 days.
   *
   * @generated from field: tracker.v1.DateRange range = 2;
   */
  range?: DateRange;

  /**
   * @generated from field: tracker.v1.PostbackResult result = 3;
   */
  result = PostbackResult.UNSPECIFIED;

  /**
   * @generated from field: string network_id = 4;
   */
  networkId = "";

  /**
   * @generated from field: string campaign_id = 5;
   */
  campaignId = "";

  /**
   * Click id prefix, event id, or any text of the raw query.
   *
   * @generated from field: string search = 6;
   */
  search = "";

  constructor(data?: PartialMessage<ListPostbacksRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ListPostbacksRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: Pagination },
    { no: 2, name: "range", kind: "message", T: DateRange },
    { no: 3, name: "result", kind: "enum", T: proto3.getEnumType(PostbackResult) },
    { no: 4, name: "network_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "campaign_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "search", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListPostbacksRequest {
    return new ListPostbacksRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListPostbacksRequest {
    return new ListPostbacksRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListPostbacksRequest {
    return new ListPostbacksRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListPostbacksRequest | PlainMessage<ListPostbacksRequest> | undefined, b: ListPostbacksRequest | PlainMessage<ListPostbacksRequest> | undefined): boolean {
    return proto3.util.equals(ListPostbacksRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.ListPostbacksResponse
 */
export class ListPostbacksResponse extends Message<ListPostbacksResponse> {
  /**
   * @generated from field: repeated tracker.v1.PostbackRecord items = 1;
   */
  items: PostbackRecord[] = [];

  /**
   * @generated from field: tracker.v1.PaginationMeta pagination = 2;
   */
  pagination?: PaginationMeta;

  /**
   * Every result under the same filters except `result` (the tabs).
   *
   * @generated from field: repeated tracker.v1.PostbackResultCount counts = 3;
   */
  counts: PostbackResultCount[] = [];

  constructor(data?: PartialMessage<ListPostbacksResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ListPostbacksResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "items", kind: "message", T: PostbackRecord, repeated: true },
    { no: 2, name: "pagination", kind: "message", T: PaginationMeta },
    { no: 3, name: "counts", kind: "message", T: PostbackResultCount, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListPostbacksResponse {
    return new ListPostbacksResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListPostbacksResponse {
    return new ListPostbacksResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListPostbacksResponse {
    return new ListPostbacksResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListPostbacksResponse | PlainMessage<ListPostbacksResponse> | undefined, b: ListPostbacksResponse | PlainMessage<ListPostbacksResponse> | undefined): boolean {
    return proto3.util.equals(ListPostbacksResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.ReplayPostbacksRequest
 */
export class ReplayPostbacksRequest extends Message<ReplayPostbacksRequest> {
  /**
   * @generated from field: repeated string event_ids = 1;
   */
  eventIds: string[] = [];

  constructor(data?: PartialMessage<ReplayPostbacksRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ReplayPostbacksRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "event_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ReplayPostbacksRequest {
    return new ReplayPostbacksRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ReplayPostbacksRequest {
    return new ReplayPostbacksRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ReplayPostbacksRequest {
    return new ReplayPostbacksRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ReplayPostbacksRequest | PlainMessage<ReplayPostbacksRequest> | undefined, b: ReplayPostbacksRequest | PlainMessage<ReplayPostbacksRequest> | undefined): boolean {
    return proto3.util.equals(ReplayPostbacksRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.ReplayPostbacksResponse
 */
export class ReplayPostbacksResponse extends Message<ReplayPostbacksResponse> {
  /**
   * Scheduled for application with today's published policy.
   *
   * @generated from field: repeated string scheduled_event_ids = 1;
   */
  scheduledEventIds: string[] = [];

  /**
   * Already accepted, another workspace's, or being applied right now.
   *
   * @generated from field: repeated string skipped_event_ids = 2;
   */
  skippedEventIds: string[] = [];

  constructor(data?: PartialMessage<ReplayPostbacksResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ReplayPostbacksResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "scheduled_event_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "skipped_event_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ReplayPostbacksResponse {
    return new ReplayPostbacksResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ReplayPostbacksResponse {
    return new ReplayPostbacksResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ReplayPostbacksResponse {
    return new ReplayPostbacksResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ReplayPostbacksResponse | PlainMessage<ReplayPostbacksResponse> | undefined, b: ReplayPostbacksResponse | PlainMessage<ReplayPostbacksResponse> | undefined): boolean {
    return proto3.util.equals(ReplayPostbacksResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.UnmappedStatus
 */
export class UnmappedStatus extends Message<UnmappedStatus> {
  /**
   * @generated from field: string network_id = 1;
   */
  networkId = "";

  /**
   * @generated from field: string network_name = 2;
   */
  networkName = "";

  /**
   * @generated from field: string raw_status = 3;
   */
  rawStatus = "";

  /**
   * @generated from field: int64 postbacks = 4;
   */
  postbacks = protoInt64.zero;

  /**
   * Sum of their payouts in USD (rows without a rate count as 0).
   *
   * @generated from field: string payout_usd = 5;
   */
  payoutUsd = "";

  /**
   * @generated from field: string last_seen_at = 6;
   */
  lastSeenAt = "";

  constructor(data?: PartialMessage<UnmappedStatus>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.UnmappedStatus";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "network_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "network_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "raw_status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "postbacks", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "payout_usd", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "last_seen_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UnmappedStatus {
    return new UnmappedStatus().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UnmappedStatus {
    return new UnmappedStatus().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UnmappedStatus {
    return new UnmappedStatus().fromJsonString(jsonString, options);
  }

  static equals(a: UnmappedStatus | PlainMessage<UnmappedStatus> | undefined, b: UnmappedStatus | PlainMessage<UnmappedStatus> | undefined): boolean {
    return proto3.util.equals(UnmappedStatus, a, b);
  }
}

/**
 * @generated from message tracker.v1.ListUnmappedStatusesRequest
 */
export class ListUnmappedStatusesRequest extends Message<ListUnmappedStatusesRequest> {
  /**
   * Default the last 30 days.
   *
   * @generated from field: tracker.v1.DateRange range = 1;
   */
  range?: DateRange;

  /**
   * @generated from field: string network_id = 2;
   */
  networkId = "";

  constructor(data?: PartialMessage<ListUnmappedStatusesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ListUnmappedStatusesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "range", kind: "message", T: DateRange },
    { no: 2, name: "network_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListUnmappedStatusesRequest {
    return new ListUnmappedStatusesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListUnmappedStatusesRequest {
    return new ListUnmappedStatusesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListUnmappedStatusesRequest {
    return new ListUnmappedStatusesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListUnmappedStatusesRequest | PlainMessage<ListUnmappedStatusesRequest> | undefined, b: ListUnmappedStatusesRequest | PlainMessage<ListUnmappedStatusesRequest> | undefined): boolean {
    return proto3.util.equals(ListUnmappedStatusesRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.ListUnmappedStatusesResponse
 */
export class ListUnmappedStatusesResponse extends Message<ListUnmappedStatusesResponse> {
  /**
   * @generated from field: repeated tracker.v1.UnmappedStatus items = 1;
   */
  items: UnmappedStatus[] = [];

  constructor(data?: PartialMessage<ListUnmappedStatusesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ListUnmappedStatusesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "items", kind: "message", T: UnmappedStatus, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListUnmappedStatusesResponse {
    return new ListUnmappedStatusesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListUnmappedStatusesResponse {
    return new ListUnmappedStatusesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListUnmappedStatusesResponse {
    return new ListUnmappedStatusesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListUnmappedStatusesResponse | PlainMessage<ListUnmappedStatusesResponse> | undefined, b: ListUnmappedStatusesResponse | PlainMessage<ListUnmappedStatusesResponse> | undefined): boolean {
    return proto3.util.equals(ListUnmappedStatusesResponse, a, b);
  }
}

/**
 * MapPostbackStatus teaches the tracker one word of a partner's status
 * vocabulary — the network's conversion_mapping gains raw_status → status —
 * publishes the network's policy, and (replay=true) applies every postback
 * that word left unmapped.
 *
 * @generated from message tracker.v1.MapPostbackStatusRequest
 */
export class MapPostbackStatusRequest extends Message<MapPostbackStatusRequest> {
  /**
   * @generated from field: string network_id = 1;
   */
  networkId = "";

  /**
   * @generated from field: string raw_status = 2;
   */
  rawStatus = "";

  /**
   * @generated from field: tracker.v1.ConversionStatus status = 3;
   */
  status = ConversionStatus.UNSPECIFIED;

  /**
   * @generated from field: bool replay = 4;
   */
  replay = false;

  constructor(data?: PartialMessage<MapPostbackStatusRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.MapPostbackStatusRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "network_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "raw_status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "status", kind: "enum", T: proto3.getEnumType(ConversionStatus) },
    { no: 4, name: "replay", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MapPostbackStatusRequest {
    return new MapPostbackStatusRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MapPostbackStatusRequest {
    return new MapPostbackStatusRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MapPostbackStatusRequest {
    return new MapPostbackStatusRequest().fromJsonString(jsonString, options);
  }

  static equals(a: MapPostbackStatusRequest | PlainMessage<MapPostbackStatusRequest> | undefined, b: MapPostbackStatusRequest | PlainMessage<MapPostbackStatusRequest> | undefined): boolean {
    return proto3.util.equals(MapPostbackStatusRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.MapPostbackStatusResponse
 */
export class MapPostbackStatusResponse extends Message<MapPostbackStatusResponse> {
  /**
   * @generated from field: repeated string scheduled_event_ids = 1;
   */
  scheduledEventIds: string[] = [];

  constructor(data?: PartialMessage<MapPostbackStatusResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.MapPostbackStatusResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "scheduled_event_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MapPostbackStatusResponse {
    return new MapPostbackStatusResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MapPostbackStatusResponse {
    return new MapPostbackStatusResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MapPostbackStatusResponse {
    return new MapPostbackStatusResponse().fromJsonString(jsonString, options);
  }

  static equals(a: MapPostbackStatusResponse | PlainMessage<MapPostbackStatusResponse> | undefined, b: MapPostbackStatusResponse | PlainMessage<MapPostbackStatusResponse> | undefined): boolean {
    return proto3.util.equals(MapPostbackStatusResponse, a, b);
  }
}

/**
 * A buyer's test click: the campaign's link opened with vt_test=<nonce>, a
 * nonce the UI made for this one check. Only such a click can receive a test
 * postback — never somebody else's click.
 *
 * @generated from message tracker.v1.FindTestClickRequest
 */
export class FindTestClickRequest extends Message<FindTestClickRequest> {
  /**
   * @generated from field: string campaign_id = 1;
   */
  campaignId = "";

  /**
   * @generated from field: string nonce = 2;
   */
  nonce = "";

  constructor(data?: PartialMessage<FindTestClickRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.FindTestClickRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "campaign_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "nonce", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FindTestClickRequest {
    return new FindTestClickRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FindTestClickRequest {
    return new FindTestClickRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FindTestClickRequest {
    return new FindTestClickRequest().fromJsonString(jsonString, options);
  }

  static equals(a: FindTestClickRequest | PlainMessage<FindTestClickRequest> | undefined, b: FindTestClickRequest | PlainMessage<FindTestClickRequest> | undefined): boolean {
    return proto3.util.equals(FindTestClickRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.FindTestClickResponse
 */
export class FindTestClickResponse extends Message<FindTestClickResponse> {
  /**
   * @generated from field: bool found = 1;
   */
  found = false;

  /**
   * @generated from field: string click_id = 2;
   */
  clickId = "";

  /**
   * RFC3339
   *
   * @generated from field: string clicked_at = 3;
   */
  clickedAt = "";

  constructor(data?: PartialMessage<FindTestClickResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.FindTestClickResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "found", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "click_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "clicked_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FindTestClickResponse {
    return new FindTestClickResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FindTestClickResponse {
    return new FindTestClickResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FindTestClickResponse {
    return new FindTestClickResponse().fromJsonString(jsonString, options);
  }

  static equals(a: FindTestClickResponse | PlainMessage<FindTestClickResponse> | undefined, b: FindTestClickResponse | PlainMessage<FindTestClickResponse> | undefined): boolean {
    return proto3.util.equals(FindTestClickResponse, a, b);
  }
}

/**
 * SendTestPostback sends ONE postback to the campaign's test click through
 * the real path — the network's own inbound URL on the campaign's domain, the
 * edge, the queue, edge-events — as the partner would. Its status is "trash"
 * with payout 0 and txid vt-test-<nonce>: the test lands in Треш, never in
 * approvals or revenue, and pressing the button again is a duplicate of the
 * same conversion, not a second one. No test click within 24 h =
 * FailedPrecondition and nothing is sent.
 *
 * @generated from message tracker.v1.SendTestPostbackRequest
 */
export class SendTestPostbackRequest extends Message<SendTestPostbackRequest> {
  /**
   * @generated from field: string campaign_id = 1;
   */
  campaignId = "";

  /**
   * @generated from field: string network_id = 2;
   */
  networkId = "";

  /**
   * @generated from field: string nonce = 3;
   */
  nonce = "";

  constructor(data?: PartialMessage<SendTestPostbackRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.SendTestPostbackRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "campaign_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "network_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "nonce", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SendTestPostbackRequest {
    return new SendTestPostbackRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SendTestPostbackRequest {
    return new SendTestPostbackRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SendTestPostbackRequest {
    return new SendTestPostbackRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SendTestPostbackRequest | PlainMessage<SendTestPostbackRequest> | undefined, b: SendTestPostbackRequest | PlainMessage<SendTestPostbackRequest> | undefined): boolean {
    return proto3.util.equals(SendTestPostbackRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.SendTestPostbackResponse
 */
export class SendTestPostbackResponse extends Message<SendTestPostbackResponse> {
  /**
   * @generated from field: string click_id = 1;
   */
  clickId = "";

  /**
   * The journal row of the postback (empty if the edge has not handed it
   * over within the wait — then result is PENDING and ListPostbacks shows it).
   *
   * @generated from field: string event_id = 2;
   */
  eventId = "";

  /**
   * @generated from field: tracker.v1.PostbackResult result = 3;
   */
  result = PostbackResult.UNSPECIFIED;

  /**
   * @generated from field: string detail = 4;
   */
  detail = "";

  /**
   * @generated from field: tracker.v1.ConversionStatus status = 5;
   */
  status = ConversionStatus.UNSPECIFIED;

  /**
   * HTTP status the edge answered the postback with (200 = accepted).
   *
   * @generated from field: int32 edge_status = 6;
   */
  edgeStatus = 0;

  constructor(data?: PartialMessage<SendTestPostbackResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.SendTestPostbackResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "click_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "result", kind: "enum", T: proto3.getEnumType(PostbackResult) },
    { no: 4, name: "detail", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "status", kind: "enum", T: proto3.getEnumType(ConversionStatus) },
    { no: 6, name: "edge_status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SendTestPostbackResponse {
    return new SendTestPostbackResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SendTestPostbackResponse {
    return new SendTestPostbackResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SendTestPostbackResponse {
    return new SendTestPostbackResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SendTestPostbackResponse | PlainMessage<SendTestPostbackResponse> | undefined, b: SendTestPostbackResponse | PlainMessage<SendTestPostbackResponse> | undefined): boolean {
    return proto3.util.equals(SendTestPostbackResponse, a, b);
  }
}

/**
 * What the campaign's lead rulings told its ad platform (decision 07). A
 * ruling on a lead is forwarded as Keitaro's S2S postback into
 * traffic-controller (tracker_edge_v2.status_forward_jobs); vibe-dispatch makes
 * the event of it and vibe-fb sends it, as for a Keitaro lead.
 *
 * @generated from message tracker.v1.SourceEvent
 */
export class SourceEvent extends Message<SourceEvent> {
  /**
   * @generated from field: string event_id = 1;
   */
  eventId = "";

  /**
   * RFC3339 — when the conversion's postback arrived
   *
   * @generated from field: string created_at = 2;
   */
  createdAt = "";

  /**
   * Facebook event name vibe-dispatch makes of the ruling (Lead, Purchase,
   * LeadRejected, LeadTrash).
   *
   * @generated from field: string event_name = 3;
   */
  eventName = "";

  /**
   * live = handed on; test = a vt_test lead's ruling, logged by vibe-dispatch
   * and sent nowhere.
   *
   * @generated from field: string mode = 4;
   */
  mode = "";

  /**
   * delivered | waiting | dead | test
   *
   * @generated from field: string state = 5;
   */
  state = "";

  /**
   * @generated from field: string delivered_at = 6;
   */
  deliveredAt = "";

  /**
   * @generated from field: string value = 7;
   */
  value = "";

  /**
   * @generated from field: string currency = 8;
   */
  currency = "";

  /**
   * @generated from field: string last_error = 9;
   */
  lastError = "";

  /**
   * @generated from field: string click_id = 10;
   */
  clickId = "";

  constructor(data?: PartialMessage<SourceEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.SourceEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "created_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "event_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "mode", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "state", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "delivered_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "last_error", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "click_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SourceEvent {
    return new SourceEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SourceEvent {
    return new SourceEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SourceEvent {
    return new SourceEvent().fromJsonString(jsonString, options);
  }

  static equals(a: SourceEvent | PlainMessage<SourceEvent> | undefined, b: SourceEvent | PlainMessage<SourceEvent> | undefined): boolean {
    return proto3.util.equals(SourceEvent, a, b);
  }
}

/**
 * @generated from message tracker.v1.ListSourceEventsRequest
 */
export class ListSourceEventsRequest extends Message<ListSourceEventsRequest> {
  /**
   * @generated from field: string campaign_id = 1;
   */
  campaignId = "";

  /**
   * At most this many, newest first; 0 = 20.
   *
   * @generated from field: int32 limit = 2;
   */
  limit = 0;

  constructor(data?: PartialMessage<ListSourceEventsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ListSourceEventsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "campaign_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListSourceEventsRequest {
    return new ListSourceEventsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListSourceEventsRequest {
    return new ListSourceEventsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListSourceEventsRequest {
    return new ListSourceEventsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListSourceEventsRequest | PlainMessage<ListSourceEventsRequest> | undefined, b: ListSourceEventsRequest | PlainMessage<ListSourceEventsRequest> | undefined): boolean {
    return proto3.util.equals(ListSourceEventsRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.ListSourceEventsResponse
 */
export class ListSourceEventsResponse extends Message<ListSourceEventsResponse> {
  /**
   * @generated from field: repeated tracker.v1.SourceEvent items = 1;
   */
  items: SourceEvent[] = [];

  constructor(data?: PartialMessage<ListSourceEventsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ListSourceEventsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "items", kind: "message", T: SourceEvent, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListSourceEventsResponse {
    return new ListSourceEventsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListSourceEventsResponse {
    return new ListSourceEventsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListSourceEventsResponse {
    return new ListSourceEventsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListSourceEventsResponse | PlainMessage<ListSourceEventsResponse> | undefined, b: ListSourceEventsResponse | PlainMessage<ListSourceEventsResponse> | undefined): boolean {
    return proto3.util.equals(ListSourceEventsResponse, a, b);
  }
}

